export const ROLE_ADMIN = 'admin'
export const ROLE_MANAGER = 'manager'
export const ROLE_INVENTORY = 'inventory'
export const ROLE_USER = 'user'
export const ROLE_STAKEHOLDER = 'stakeholder'
export const ROLE_DRIVER = 'driver'
